
// export const local = "https://ims.ekedc.com";


export const local = "https://imstest.ekedc.com"

// export const local = "http://127.0.0.1:5000"
